import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLearnPitch = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 1.6,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M9 18V6l10-2v12" }),
		/* @__PURE__ */ _jsx("circle", {
			cx: 6.5,
			cy: 18,
			r: 2.5
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 16.5,
			cy: 16,
			r: 2.5
		})
	]
});
export default SvgLearnPitch;
